module.exports = __webpack_public_path__ + "img/photo-bio.8ef9ed90.jpg";